import React from "react";
import { useLocale } from "../../context/LocaleContext";
import { Box, Paper, Typography, Stack, Collapse, Grid, Button } from "@mui/material";
import { CustomChip, config } from "./CustomChips";

export default function InventoryItem(props) {
	const { messages } = useLocale();
	return (
		<Box sx={{ marginBottom: '12px' }}>
			<Button variant="text" sx={{ color: 'revert', textTransform: 'none', width: '100%', padding: 0, borderRadius: '5px', border: 'none', marginBottom: '5px' }} onClick={props.setExpanded}>
				<Paper elevation={3} sx={{ width: '100%', padding: '10px 20px' }}>
					<Grid container alignItems='center'>
						<Grid item xs={7} sm={9} md={10} lg={10.5}>
							<Typography width='fit-content' textAlign="left" fontSize="1.1rem">{props.item_name}</Typography>
						</Grid>
						<Grid item xs={5} sm={3} md={2} lg={1.5}>
							<Stack flexDirection="column" alignContent="center" justifyContent="space-between">
								<Typography textAlign="center" fontSize="1rem">x {props.quantity}</Typography>
								<CustomChip {...config[props.risk]} label={messages.inventory.chips[props.risk]} />
							</Stack>
						</Grid>
					</Grid>
				</Paper>
			</Button>
			<Collapse in={props.expanded}>
				<Paper elevation={3} sx={{ borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
					<Stack rowGap={2} p="20px">
						<Grid container alignItems="center">
							<Grid item xs={7} sm={6} md={4} lg={3}>
								<Typography fontWeight={500} fontSize="1.2rem">{messages.inventory.popup.quantity} : </Typography>
							</Grid>
							<Grid item xs={5} sm={6} md={8} lg={9}>
								<Typography>{props.quantity}</Typography>
							</Grid>
						</Grid>
						<Grid container alignItems="center">
							<Grid item xs={7} sm={6} md={4} lg={3}>
								<Typography fontWeight={500} fontSize="1.2rem">{messages.inventory.popup.cost} : </Typography>
							</Grid>
							<Grid item xs={5} sm={6} md={8} lg={9}>
								<Typography>{props.cost_price}</Typography>
							</Grid>
						</Grid>
						<Grid container alignItems="center">
							<Grid item xs={7} sm={6} md={4} lg={3}>
								<Typography fontWeight={500} fontSize="1.2rem">{messages.inventory.popup.selling} : </Typography>
							</Grid>
							<Grid item xs={5} sm={6} md={8} lg={9}>
								<Typography>{props.selling_price}</Typography>
							</Grid>
						</Grid>
						<Grid container alignItems="center">
							<Grid item xs={7} sm={6} md={4} lg={3}>
								<Typography fontWeight={500} fontSize="1.2rem">{messages.inventory.popup.understock} : </Typography>
							</Grid>
							<Grid item xs={5} sm={6} md={8} lg={9}>
								<Typography>{props.understock_qt}</Typography>
							</Grid>
						</Grid>
						<Grid container alignItems="center">
							<Grid item xs={7} sm={6} md={4} lg={3}>
								<Typography fontWeight={500} fontSize="1.2rem">{messages.inventory.popup.overstock} : </Typography>
							</Grid>
							<Grid item xs={5} sm={6} md={8} lg={9}>
								<Typography>{props.overstock_qt}</Typography>
							</Grid>
						</Grid>
						<Grid container alignItems="center">
							<Grid item xs={7} sm={6} md={4} lg={3}>
								<Typography fontWeight={500} fontSize="1.2rem">{messages.inventory.popup.barcode} : </Typography>
							</Grid>
							<Grid item xs={5} sm={6} md={8} lg={9}>
								<Typography>{props.barcode_id}</Typography>
							</Grid>
						</Grid>
					</Stack>
				</Paper>
			</Collapse>
		</Box>
	)
}